import Home from "./pages/Home";
import "./styles/app.scss";
function App() {
  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;
